import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PolygonChecks, type PolygonChecksProps } from './PolygonChecks'

/**
 * A page that is only this application: `PolygonChecks` full-page, owning
 * the address bar. For one application inside another, render the component
 * instead.
 */
export function startPolygonChecks(
  root: HTMLElement,
  props: Omit<PolygonChecksProps, 'router' | 'fullPage'>,
) {
  createRoot(root).render(
    <StrictMode>
      <PolygonChecks {...props} router="browser" fullPage />
    </StrictMode>,
  )
}
